import { updateBusiness } from '../../../data/repositories/businessRepository.js';

export const editBusiness = (id, payload) => updateBusiness(id, payload);
